export default "__VITE_PUBLIC_ASSET__7cc67379__"